/* Packages */
import React from "react";
import RadioList from "@webstores/webstores-configurator/dist/inputs/RadioList";

/* Components */
import TextField from "../inputs/CustomTextField";
import {Button, PriceFormat} from '../../../common';
import {ISDESKTOP} from '../../../../constants';

/* Logos */
import GeldLenenKostGeld from "./logos/GeldLenenKostGeld";

export default function ConversionProductFinanceCalculator({
    stepData,
    setStepData,
    title,
    isLoading
}) {
    /* Constants */
    const { data, inputs } = stepData;

    /* Functions */
    const getFormatedValue = (number) => {
        return new Intl.NumberFormat("nl-NL").format(parseInt(number));
    };

    /* Render */
    return (
        <>
            <h3 className="h2 mb-6 mb-lg-10">{title}</h3>
            <div className="row gutters-3">
                <div className="col-12 col-lg-10 col-xl-9">
                    <div className="row gutters-3 align-items-center mb-6 mb-lg-10">
                        <div className="col-12">
                            <div className="card card--loan">
                                <div className="card-body py-1 px-4">
                                    <GeldLenenKostGeld />
                                </div>
                            </div>
                        </div>
                        <div className="col-5">
                            <p>{inputs.deposit.label}</p>
                        </div>
                        <div className="col-7">
                            <div className="d-flex align-items-center">
                                <p className="font-weight-normal mb-0 mr-4">€</p>
                                <TextField
                                    id="finance-deposit"
                                    className="form-control"
                                    input={inputs.deposit}
                                    stepData={stepData}
                                    setStepData={setStepData}
                                    field={"inputs.deposit"}
                                    preventUpdate={false}
                                    formatNumber={true}
                                />
                            </div>
                        </div>
                        <div className="col-5">
                            <p>{inputs.credit.label}</p>
                        </div>
                        <div className="col-7">
                            <div className="d-flex align-items-center">
                                <p className="font-weight-normal mb-0 mr-4">€</p>
                                <p className="px-4">{getFormatedValue(inputs.credit.value)}</p>
                            </div>
                        </div>
                        <div className="col-5">
                            <p className="mb-0">{inputs.duration.label}</p>
                            <p className="text--footnote text-muted--40">{inputs.duration.subLabel}</p>
                        </div>
                        <div className="col-7">
                            <div className="row gutters-1 ml-6 ml-lg-7">
                                <RadioList
                                    id="finance-duration"
                                    className="col custom-control custom-radio custom-radio--buttons"
                                    inputClassName="custom-control-input"
                                    labelClassName="custom-control-label"
                                    input={inputs.duration}
                                    stepData={stepData}
                                    setStepData={setStepData}
                                    preventUpdate={false}
                                    field={"inputs.duration"}
                                />
                            </div>
                        </div>
                        <div className="col-5">
                            <p>{inputs['final-term'].label}</p>
                        </div>
                        <div className="col-7">
                            <div className="d-flex align-items-center">
                                <p className="font-weight-normal mb-0 mr-4">€</p>
                                <TextField
                                    id="finance-final-term"
                                    className="form-control"
                                    input={inputs['final-term']}
                                    stepData={stepData}
                                    setStepData={setStepData}
                                    field={"inputs.final-term"}
                                    preventUpdate={false}
                                    formatNumber={true}
                                />
                            </div>
                        </div>
                        <div className="col-5 mt-4">
                            <p>Uw maandbedrag</p>
                        </div>
                        <div className="col-7 mt-4">
                            <PriceFormat className="h4" value={data.additionalData.pricePerMonth} />
                        </div>
                    </div>
                    <div className="row gutters-3 mb-4 mb-lg-10">
                        <div className="col-12 col-lg-5">
                            <Button
                                classes={ISDESKTOP ? "" : "w-100"}
                                linkTitle="Volgende stap"
                                isLoading={isLoading}
                                type="submit"
                            />
                        </div>
                        <div className="col-12 col-lg-7">
                            <div className="d-flex align-items-center h-100">
                                <p className="text-muted--60">Nog maar 1 stap te gaan hierna!</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
